import { render, staticRenderFns } from "./EmailPasswordResetPasswordConfirmStep.vue?vue&type=template&id=d445d0f6&scoped=true&"
import script from "./EmailPasswordResetPasswordConfirmStep.vue?vue&type=script&lang=js&"
export * from "./EmailPasswordResetPasswordConfirmStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d445d0f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VRow,VSpacer})
